import { useState, MouseEvent } from "react"
import {
  Box,
  Grid,
  Typography
} from "@mui/material"

interface Props {
  title?: string,
  subtitle?: string,
  date?: string,
  link?: string,
  media?: any[],
  border?: boolean
}

const random_number = (a: number = 0, b: number = 0) => a+(b-a)*Math.random()

const random_integer = (a: number = 0, b: number = 1) => Math.floor(random_number(a, b+1))

const Project = ({ title="", subtitle="", date="", link="", media=[], border=true }: Props) => {
  const [hover, setHover] = useState(false)
  const [hoverMedia, setHoverMedia] = useState(null)
  const [mouseX, setMouseX] = useState(0)
  const [mouseY, setMouseY] = useState(0)
  const handleMouseEnter = (e: MouseEvent<HTMLDivElement>) => {
    setHover(true)
    setMouseX(e.clientX)
    setMouseY(e.clientY)
    if (media.length > 0) {
      setHoverMedia(media[random_integer(0, media.length-1)])
    }
  }
  const handleMouseLeave = () => {
    setHover(false)
  }
  return (
    <>
      <Box
        m = {0}
        p = {0.3}
        pl = {4}
        pr = {4}
        borderBottom = {border ? "1px dotted #00000050": "none"}
        onMouseEnter = {handleMouseEnter}
        onMouseLeave = {handleMouseLeave}
        onClick={() => {
          if (link !== "") {
            window.open(link)
          }
        }}
        sx = {{
          style : {
            "color": "black",
            "textDecoration": "none",
          },
          "&:hover" : {
            color: "black",
            backgroundColor: "#00000015",
            cursor: "crosshair",
            textDecoration: "none"
          }
        }}
      >
        <Grid container wrap="wrap">
          <Grid item xs={10} style={{ textAlign: "left" }}>
            <Typography fontSize="1.0rem">
              {title}
            </Typography>
            <Typography mt={-0.2} fontFamily="General Sans" fontSize="0.8rem">
              {subtitle}
            </Typography>
          </Grid>
          <Grid item xs={2} style={{ textAlign: "right" }}>
            <Typography fontSize="0.85rem">
              {date}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      { hover && (
        <Box
          border = "1px dotted #00000050"
          sx = {{
            position: "fixed",
            top: mouseY - 50,
            left: mouseX + 50,
            width: "400px",
            height: "auto",
            pointerEvents: "none",
            zIndex: 1000,
          }}
        >
          {hoverMedia}
        </Box>
      )}
    </>
  )
}

export default Project
